import { useEffect } from 'react';
import { getFormFactor, useDeviceStore } from '@namespace/device';
import { PLEX_LIMIT } from '@namespace/games';
import { useI18n } from '@namespace/i18n';
import { useGetUserSegments } from '@namespace/segments';
import { useUserInfoLoaded } from '@namespace/user';
import { useVirtualSportsStore, virtualSportsActions } from '../../../store';

export const useLoadVirtualSportsDataPlex = ({ feedName = '' }) => {
  const { feed } = useVirtualSportsStore(['feed']);
  const { GET_VIRTUAL_SPORTS_FEED_PLEX, SET_IS_VIRTUAL_SPORTS_FEED_LOADING } =
    virtualSportsActions;
  const { deviceFormFactor } = useDeviceStore();
  const { isLoading: isFeedLoading, isLoaded: isFeedLoaded } = feed;
  const { userSegmentsNames: userSegments } = useGetUserSegments();
  const { userInfoLoaded } = useUserInfoLoaded();
  const formFactor = getFormFactor(deviceFormFactor);
  const { language } = useI18n();

  useEffect(() => {
    if (!isFeedLoaded && feedName && !isFeedLoading && userInfoLoaded) {
      SET_IS_VIRTUAL_SPORTS_FEED_LOADING(true);
      // for virtual-sports lobby using PLEX_LIMIT (200) for getting data, to be sure that we load everything
      // but usually its 3-20 games per category
      GET_VIRTUAL_SPORTS_FEED_PLEX({
        platform: formFactor,
        feedName,
        userSegments,
        lang: language,
        filter: {
          limit: PLEX_LIMIT
        }
      });
    }
  }, [
    isFeedLoaded,
    isFeedLoading,
    formFactor,
    feedName,
    userSegments,
    GET_VIRTUAL_SPORTS_FEED_PLEX,
    SET_IS_VIRTUAL_SPORTS_FEED_LOADING,
    userInfoLoaded
  ]);
};
